import withType from 'components/common/hoc/withType'
import SearchRadius from './SearchRadius'

export default withType({ type: 'BOTStoreLocatorSearchRadius' })(SearchRadius)
